import ReadOnlyFields from './ReadOnlyFields'

export default ReadOnlyFields
